import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 6);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              最近更新
            </h2>
            <p className="text-sm text-foreground-600 mt-2">每日新鲜韩漫内容，精彩不间断</p>
          </div>
          <Link to="/category/all" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-lg hover:bg-primary-50/50 transition-colors group cursor-pointer"
            >
              <div className="w-16 h-20 rounded-md overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩漫之家`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-1">{comic.author}</p>
                <p className="text-xs text-foreground-500 mt-1 flex items-center gap-1 flex-wrap">
                  <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded text-xs">{comic.categoryName}</span>
                  <span>更新至 {comic.chapters} 话</span>
                </p>
              </div>
              <div className="flex-shrink-0 text-xs text-foreground-600 flex flex-col items-end gap-1">
                <span className="text-accent-500 font-medium">{comic.status}</span>
                <span>{comic.updatedAt}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}